export default {
    all_orders: [],
    errorOrdersData: [],
    totalOrders: 0,
    totalPrice: 0,
    totalDiscount: 0,
    totalFinalPrice: 0,
    currentPage: 1,
    to: 0,
    from: 1,
    where: '',
    statuses: [],
    restaurants: [],
    operators: [],
    brands: [],
    filtersForOrders: {},
    view_order: {},
    notifications: null,
    numberOfOrdersWithSendError: 0,

    interval: {},

    paramsSearch: {
        num: null,
        externalNum: null,
        transaction: null,
        statuses: [],
        operator: null,
        phone: null,
        address: null,
        price: null,
        division: null,
        orderCreatePeriod: null,
        brand: null,
        orderType: null,
    },
    stopList: [],
    timeUpdateList: 0,
    cookeryIntervals: [],
    managerNotifications: {
        canceledOrderNotification: null,
        changedOrderNotification: null,
        dispatcherOrderNotifications: [],
    },
    previewOrderId: null,
    unblockedOrder: null,
    confirmedUnblockedOrderId: null,
    unblockTimer: null,
}
